import { DatePipe } from '@angular/common';

/**
 * How a timeline block stamps its date. The full year, as every other date in the app: a history
 * reaches back decades, and a legal date may stand in the same timeline.
 */
const TIMESTAMP_FORMAT = 'dd.MM.yyyy, HH:mm';

/**
 * «21.01.2025, 10:00», or an empty string where a block carries no timestamp.
 *
 * @param {Date | null} timestamp - When the entry was written
 * @param {DatePipe} datePipe - Formats the timestamp in the active locale
 * @returns {string} The stamp shown beside the author
 */
export function formatVerlaufTimelineTimestamp(timestamp: Date | null, datePipe: DatePipe): string {
  return (timestamp ? datePipe.transform(timestamp, TIMESTAMP_FORMAT) : '') ?? '';
}
